module.exports = __webpack_public_path__ + "static/media/paint.5115bef1.jpg";